import _get from 'lodash/get'

import {
    EMPLOYMENT_SAVE_ERROR,
    EMPLOYMENT_SAVE_SUCCESS,
    EMPLOYMENT_SAVING,
    RECEIVE_EMPLOYMENTS,
    REMOVE_EMPLOYMENT,
    REQUEST_EMPLOYMENTS,
} from '../actions'
import { updateOrAddItemsById } from '../helpers'

export default (
    state = {
        activeEmploymentIndex: 0,
        activeQuestionIndex: 0,
        fetchSuccessful: null,
        isFetching: false,
        items: [],
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_EMPLOYMENTS:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_EMPLOYMENTS: {
            const { items: currentItems } = state
            const { items: receivedItems } = data

            const items = updateOrAddItemsById({ currentItems, receivedItems })

            return { ...state, isFetching: false, ...data, items }
        }

        case REMOVE_EMPLOYMENT: {
            const { items: currentItems } = state
            const { id } = data

            const items = currentItems.filter((o) => o.id !== id)

            return {
                ...state,
                items,
            }
        }

        case EMPLOYMENT_SAVING:
            return { ...state, isSaving: true }

        case EMPLOYMENT_SAVE_SUCCESS:
            return {
                ...state,
                ...data,
                isSaving: false,
                goToNextQuestion: true,
                saveError: false,
                errorMessage: '',
                validationErrors: null,
            }

        case EMPLOYMENT_SAVE_ERROR:
            return {
                ...state,
                ...data,
                isSaving: false,
                goToNextQuestion: false,
                saveError: true,
                errorMessage: _get(action, ['errorResponse', 'message'], 'Unknown error occurred'),
                validationErrors: _get(action, ['errorResponse', 'modelState'], false),
            }

        default:
            return state
    }
}
